<template lang="html">
    <div class="detail">
        <common-header></common-header>
        <div class="page">
            <div class="wrapper-content container">
                <div class="ibox-title ">
                    <h5 class="text-center">完善会员资料</h5>
                </div>
                <div class="box">
                    <form>
                        <div class="row border-bottom">
                            <div class="col-sm-3">
                                <div class="card" style="border:none;">
                                    <div class="border" :data-titie="formData1.photo ? '' : '照片'"
                                        :class="!formData1.photo ? 'minHeight' : ''">
                                        <img class="card-img-top" :src="formData1.photo">
                                    </div>
                                    <div class="card-body">
                                        <div class="custom-file">
                                            <input type="file" class="custom-file-input" id="customFile"
                                                @change="uploadImage">
                                            <label class="custom-file-label" for="customFile"
                                                :data-avatar="formData1.photo ? '重新上传' : '上传图片'"></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="col-sm-3">
                  <div class="card" style="border:none;">
                    <div class="border" :class="!formData1.photo?'minHeight':''">
                      <img class="card-img-top" :src="formData1.photo">
                    </div>
                  </div>
                </div> -->
                            <div class="col-sm-4">
                                <div class="form-group row no-gutters">
                                    <label for="staticEmail" class="col-sm-4 col-form-label"><span
                                            class="red"></span>姓名：</label>
                                    <div class="col-sm-8">
                                        <input type="text" disabled class="form-control" v-model="formData1.name"
                                            placeholder="">
                                        <!-- <span class="form-span">{{formData1.name}}</span> -->
                                    </div>
                                </div>
                                <div class="form-group row no-gutters">
                                    <label for="staticEmail" class="col-sm-4 col-form-label">笔名/艺名：</label>
                                    <div class="col-sm-8">
                                        <input type="text" class="form-control" v-model="formData1.penname" placeholder="">
                                        <!-- <span class="form-span">{{formData1.penname}}</span> -->
                                    </div>
                                </div>
                                <div class="form-group row no-gutters">
                                    <label for="staticEmail" class="col-sm-4 col-form-label"><span
                                            class="red"></span>身份证号：</label>
                                    <div class="col-sm-8">
                                        <input type="text" disabled class="form-control" v-model="formData1.idnumber"
                                            @input="idcardInput" placeholder="" maxlength="18">
                                        <!-- <span class="form-span">{{formData1.idnumber}}</span> -->
                                    </div>
                                </div>
                                <div class="form-group row no-gutters">
                                    <label for="staticEmail" class="col-sm-4 col-form-label"><span
                                            class="red"></span>性别：</label>
                                    <div class="col-sm-8 alignCenter">
                                        <div class="form-check form-check-inline">
                                            <input disabled class="form-check-input" type="radio" name="inlineRadioOptions"
                                                id="inlineRadio1" v-model="formData1.gender" value="1"
                                                :checked="formData1.gender == 1">
                                            <label class="form-check-label" for="inlineRadio1">男</label>
                                        </div>
                                        <div class="form-check form-check-inline">
                                            <input disabled class="form-check-input" type="radio" name="inlineRadioOptions"
                                                id="inlineRadio2" v-model="formData1.gender" value="0"
                                                :checked="formData1.gender == 0">
                                            <label class="form-check-label" for="inlineRadio2">女</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row no-gutters">
                                    <label for="staticEmail" class="col-sm-4 col-form-label"><span
                                            class="red"></span>出生日期：</label>
                                    <div class="col-sm-8">
                                        <birth-date :disabled="true" ref="birthdate" v-if="formData1.birthdate"
                                            @getBirthdate="getBirthdate"
                                            v-bind:default="formData1.birthdate ? formData1.birthdate : '2019-01-01'"></birth-date>
                                        <!-- <span class="form-span">{{ formData1.birthdate }}</span> -->
                                    </div>
                                </div>
                                <div class="form-group row no-gutters">
                                    <label for="staticEmail" class="col-sm-4 col-form-label"><span
                                            class="red">*</span>民族：</label>
                                    <div class="col-sm-8">
                                        <select id="inputState" class="form-control" v-model="formData1.nation">
                                            <option value="">请选择民族</option>
                                            <option v-for="item in nation" :value="item">{{ item }}</option>
                                        </select>
                                        <!-- <span class="form-span">{{formData1.nation}}</span> -->
                                    </div>
                                </div>
                                <div class="form-group row no-gutters">
                                    <label for="staticEmail" class="col-sm-4 col-form-label"><span
                                            class="red">*</span>政治面貌：</label>
                                    <div class="col-sm-8">
                                        <select id="inputState" class="form-control" v-model="formData1.political">
                                            <option value="">请选择政治面貌</option>
                                            <option v-for="item in politicalBackground" :value="item.name">{{ item.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group row no-gutters">
                                    <label for="staticEmail" class="col-sm-4 col-form-label"><span
                                            class="red">*</span>文化程度：</label>
                                    <div class="col-sm-8">
                                        <select id="inputState" class="form-control" v-model="formData1.education">
                                            <option value="">请选择文化程度</option>
                                            <option v-for="item in culture" :value="item">{{ item }}</option>
                                        </select>
                                        <!-- <span class="form-span">{{formData1.education}}</span> -->
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group row no-gutters">
                                    <label for="staticEmail" class="col-sm-4 col-form-label"><span
                                            class="red">*</span>籍贯：</label>
                                    <div class="col-sm-8">
                                        <input type="text" class="form-control" v-model="formData1.birthplace"
                                            placeholder="">
                                        <!-- <span class="form-span">{{formData1.birthplace}}</span> -->
                                    </div>
                                </div>
                                <div class="form-group row no-gutters">
                                    <label for="staticEmail" class="col-sm-4 col-form-label"><span
                                            class="red">*</span>工作单位：</label>
                                    <div class="col-sm-8">
                                        <input type="text" class="form-control" v-model="formData1.employer" placeholder="">
                                        <!-- <span class="form-span">{{formData1.employer}}</span> -->
                                    </div>
                                </div>
                                <div class="form-group row no-gutters">
                                    <label for="staticEmail" class="col-sm-4 col-form-label"><span
                                            class="red">*</span>单位性质：</label>
                                    <div class="col-sm-8">
                                        <!-- <span class="form-span">{{formData1.employer}}</span> -->
                                        <select class="form-control" v-model="formData1.employer_type">
                                            <option value="">请选择单位性质</option>
                                            <option :value="str" v-for="str in types.split('、')">{{ str }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group row no-gutters">
                                    <label for="staticEmail" class="col-sm-4 col-form-label overflowAuto"><span
                                            class="red">*</span>职务：</label>
                                    <div class="col-sm-8">
                                        <input type="text" class="form-control" v-model="formData1.position" placeholder="">
                                        <!-- <span class="form-span">{{formData1.position}}</span> -->
                                    </div>
                                </div>
                                <div class="form-group row no-gutters">
                                    <label for="staticEmail" class="col-sm-4 col-form-label"><span
                                            class="red">*</span>职称：</label>
                                    <div class="col-sm-8">
                                        <input type="text" class="form-control" v-model="formData1.positiontitle"
                                            placeholder="">
                                        <!-- <span class="form-span">{{formData1.positiontitle}}</span> -->
                                    </div>
                                </div>

                                <div class="form-group row no-gutters">
                                    <label for="staticEmail" class="col-sm-4 col-form-label">申请协会：</label>
                                    <div class="col-sm-8">
                                        <input disabled type="text" class="form-control" v-model="formData1.union"
                                            placeholder="">
                                        <!-- <span class="form-span">{{formData1.union}}</span> -->
                                    </div>
                                </div>
                                <div class="form-group row no-gutters">
                                    <label for="staticEmail" class="col-sm-4 col-form-label">会员编号：</label>
                                    <div class="col-sm-8">
                                        <input type="text" class="form-control" v-model="formData1.memberid" placeholder=""
                                            disabled>
                                        <!-- <span class="form-span">{{formData1.union}}</span> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row part border-bottom">
                            <div class="col-sm-5">
                                <div class="form-group row no-gutters">
                                    <label for="staticEmail" class="col-sm-3 col-form-label"><span
                                            class="red"></span>通讯地址：</label>
                                    <div class="col-sm-8 ">
                                        <input type="text" class="form-control" v-model="formData1.address" placeholder="">
                                        <!-- <span class="form-span address">{{formData1.address}}</span> -->
                                    </div>
                                </div>
                                <div class="form-group row no-gutters">
                                    <label for="staticEmail" class="col-sm-3 col-form-label">邮编：</label>
                                    <div class="col-sm-8">
                                        <input type="text" class="form-control" v-model="formData1.postcode" placeholder="">
                                        <!-- <span class="form-span">{{formData1.postcode}}</span> -->
                                    </div>
                                </div>
                                <div class="form-group row no-gutters">
                                    <label for="staticEmail" class="col-sm-3 col-form-label">办公电话：</label>
                                    <div class="col-sm-8">
                                        <input type="text" class="form-control" v-model="formData1.officephone"
                                            placeholder="">
                                        <!-- <span class="form-span">{{formData1.officephone}}</span> -->
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-5 offset-sm-2">
                                <div class="form-group row no-gutters">
                                    <label for="staticEmail" class="col-sm-3 col-form-label">家庭电话：</label>
                                    <div class="col-sm-8">
                                        <input type="text" class="form-control" v-model="formData1.telephone"
                                            placeholder="">
                                        <!-- <span class="form-span">{{formData1.telephone}}</span> -->
                                    </div>
                                </div>
                                <div class="form-group row no-gutters">
                                    <label for="staticEmail" class="col-sm-3 col-form-label">电子邮箱：</label>
                                    <div class="col-sm-8">
                                        <input type="text" class="form-control" v-model="formData1.email" placeholder="">
                                        <!-- <span class="form-span">{{formData1.email}}</span> -->
                                    </div>
                                </div>
                                <div class="form-group row no-gutters">
                                    <label for="staticEmail" class="col-sm-3 col-form-label"><span
                                            class="red">*</span>微信号：</label>
                                    <div class="col-sm-8">
                                        <input type="text" class="form-control" v-model="formData1.wechat" placeholder="">
                                        <!-- <span class="form-span">{{formData1.wechat}}</span> -->
                                    </div>
                                </div>
                                <div class="form-group row no-gutters">
                                    <label for="staticEmail" class="col-sm-3   col-form-label"><span
                                            class="red"></span>手机号：</label>
                                    <div class="col-sm-8">
                                        <input disabled type="text" class="form-control" v-model="formData1.mobile"
                                            placeholder="">
                                        <!-- <span class="form-span">{{formData1.mobile}}</span> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row part border-bottom">
                            <div class="col-sm-4">
                                <div class="form-group row no-gutters">
                                    <label for="staticEmail" class="col-sm-4 col-form-label">国家级会员：</label>
                                    <div class="col-sm-8">
                                        <month-picker v-if="formData1" v-bind:default="formData1.joindate_n"
                                            v-on:getChildDate="catchChildDate1"></month-picker>
                                        <!-- <span class="form-span">{{checkTime(formData1.joindate_n)}}</span> -->
                                    </div>
                                </div>
                                <div class="form-group row no-gutters">
                                    <label for="staticEmail" class="col-sm-4 col-form-label">省级会员：</label>
                                    <div class="col-sm-8">
                                        <month-picker v-if="formData1" v-bind:default="formData1.joindate_p"
                                            v-on:getChildDate="catchChildDate2"></month-picker>
                                        <!-- <span class="form-span">{{checkTime(formData1.joindate_p)}}</span> -->
                                    </div>
                                </div>
                                <div class="form-group row no-gutters">
                                    <label for="staticEmail" class="col-sm-4 col-form-label">市级会员：</label>
                                    <div class="col-sm-8">
                                        <month-picker v-if="formData1" v-bind:default="formData1.joindate_c"
                                            v-on:getChildDate="catchChildDate3"></month-picker>
                                        <!-- <span class="form-span">{{checkTime(formData1.joindate_c)}}</span> -->
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group row no-gutters">
                                    <label for="staticEmail" class="col-sm-4 col-form-label">会员证编号：</label>
                                    <div class="col-sm-8">
                                        <input type="text" class="form-control" v-model="formData1.mid_n" placeholder="">
                                        <!-- <span class="form-span">{{formData1.mid_n}}</span> -->
                                    </div>
                                </div>
                                <div class="form-group row no-gutters">
                                    <label for="staticEmail" class="col-sm-4 col-form-label">会员证编号：</label>
                                    <div class="col-sm-8">
                                        <input type="text" class="form-control" v-model="formData1.mid_p" placeholder="">
                                        <!-- <span class="form-span">{{formData1.mid_p}}</span> -->
                                    </div>
                                </div>
                                <div class="form-group row no-gutters">
                                    <label for="staticEmail" class="col-sm-4 col-form-label">会员证编号：</label>
                                    <div class="col-sm-8">
                                        <input type="text" class="form-control" v-model="formData1.mid_c" placeholder="">
                                        <!-- <span class="form-span">{{formData1.mid_c}}</span> -->
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group row no-gutters">
                                    <label for="staticEmail" class="col-sm-4 col-form-label">协会职务：</label>
                                    <div class="col-sm-8">
                                        <input type="text" class="form-control" v-model="formData1.posi_n" placeholder="">
                                        <!-- <span class="form-span">{{formData1.posi_n}}</span> -->
                                    </div>
                                </div>
                                <div class="form-group row no-gutters">
                                    <label for="staticEmail" class="col-sm-4 col-form-label">协会职务：</label>
                                    <div class="col-sm-8">
                                        <input type="text" class="form-control" v-model="formData1.posi_p" placeholder="">
                                        <!-- <span class="form-span">{{formData1.posi_p}}</span> -->
                                    </div>
                                </div>
                                <div class="form-group row no-gutters">
                                    <label for="staticEmail" class="col-sm-4 col-form-label">协会职务：</label>
                                    <div class="col-sm-8">
                                        <input type="text" class="form-control" v-model="formData1.posi_c" placeholder="">
                                        <!-- <span class="form-span">{{formData1.posi_c}}</span> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row part step2">
                            <div class="col-sm-12">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <h5 class="sub-tit"><span class="red"></span>主要艺术成就及获奖情况：</h5>
                                    </div>
                                    <div class="col-sm-11" style="overflow-x: auto;">
                                        <div class="">
                                            <table class="table">
                                                <thead class="">
                                                    <tr scope="row">
                                                        <th class="text-center" scope="col">时间</th>
                                                        <th class="text-center" scope="col">地点</th>
                                                        <th class="text-center" scope="col">主办单位</th>
                                                        <th class="text-center" scope="col">著作出版社</th>
                                                        <th class="text-center" scope="col">作品或获奖情况</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-if="formData2 && formData2.awards"
                                                        class="text-center border-bottom"
                                                        v-for="(item, index) in formData2.awards">
                                                        <td style="width:20%;">
                                                            <div class="form-group position-relative"
                                                                @click.stop.prevent="showDatepicker(index)">
                                                                <month-picker v-bind:default="item.date"
                                                                    v-bind:index="index"
                                                                    v-on:getChildDate="catchChildDate"></month-picker>
                                                                <!-- <input type="text" name="place" class="form-control" placeholder="" required="" v-model="item.date" readonly>
                                  <date-picker v-bind:index="index" v-bind:show="datepickerShow[index]" v-on:getChildDate="catchChildDate"></date-picker> -->
                                                            </div>
                                                            <!-- {{item.date}} -->
                                                        </td>
                                                        <td>
                                                            <div class="form-group">
                                                                <input type="text" name="place" class="form-control"
                                                                    placeholder="" required="" v-model="item.place">
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="form-group">
                                                                <input type="text" name="place" class="form-control"
                                                                    placeholder="" required="" v-model="item.organizer">
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="form-group">
                                                                <input type="text" name="place" class="form-control"
                                                                    placeholder="" required="" v-model="item.press">
                                                            </div>
                                                        </td>

                                                        <td>
                                                            <div class="form-group">
                                                                <input type="text" name="place" class="form-control"
                                                                    placeholder="" required="" v-model="item.awards">
                                                            </div>
                                                        </td>
                                                        <td><span class="remove" @click="removeStep2(index)">-</span></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="col-sm-1">
                                        <div class="btn btn-secondary" @click="addStep2">
                                            增加
                                        </div>
                                    </div>

                                    <div class="row col-sm-12 upload-image">
                                        <div class="col-sm-auto " v-if="!formData2.photos || !formData2.photos.length">
                                            <div class="example-img fixedWidth">
                                            </div>
                                        </div>
                                        <div class="col-sm-auto" v-for="(item, index) in formData2.photos">
                                            <div class="example-img position-relative">
                                                <img :src="item.path" alt="">
                                                <span class="delPhoto" @click="removePhoto(index)">×</span>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-file">
                                                <input type="file" class="custom-file-input" id="customFile"
                                                    @change="photosUpload">
                                                <label class="custom-file-label" for="customFile"></label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="row part step2 border-top">
                            <div class="col-sm-12">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <h5 class="sub-tit"><span class="red"></span>工作经历：</h5>
                                    </div>
                                    <div class="col-sm-11" style="overflow-x: auto;">
                                        <div class="">
                                            <table class="table">
                                                <thead class="">
                                                    <tr scope="row">
                                                        <th class="text-center" scope="col">起始年月</th>
                                                        <th class="text-center" scope="col">结束年月</th>
                                                        <th class="text-center" scope="col">主要经历</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-if="formData3.length" class="text-center"
                                                        v-for="(item, index) in formData3">
                                                        <td>
                                                            <div class="form-group">
                                                                <month-picker v-if="formData3"
                                                                    v-bind:default="item.startdate" v-bind:index="index"
                                                                    v-on:getChildDate="catchStep3Start"></month-picker>
                                                                <!-- <input type="text" name="place" class="form-control" placeholder="" required="" v-model="item.startdate" > -->
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="form-group">
                                                                <month-picker v-if="formData3" v-bind:default="item.enddate"
                                                                    v-bind:index="index"
                                                                    v-on:getChildDate="catchStep3End"></month-picker>
                                                                <!-- <input type="text" name="place" class="form-control" placeholder="" required="" v-model="item.enddate" > -->
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="form-group">
                                                                <input type="text" name="place" class="form-control"
                                                                    placeholder="" required="" v-model="item.exp">
                                                            </div>
                                                        </td>
                                                        <td><span class="remove" @click="removeStep3(index)">-</span></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="col-sm-1">
                                        <div class="btn btn-secondary" @click="addStep3">
                                            增加
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

        </div>
        <div class="row justify-content-md-center">
            <div class="form-group" style="margin: 0 auto;">
                <div class="btn btn-primary" @click="save(1)">
                    提交
                </div>
            </div>
        </div>
        <alert-model v-bind:func="alertFunc" v-bind:show="alertShow" v-on:close="catchClose"
            v-bind:msg="tips"></alert-model>
    </div>
</template>
  
<script>
import birthDate from './birthdate.vue'
import commonHeader from './header.vue'
import stepSecond from './step2.vue'
import stepThird from './step3.vue'
import mapPicker from './map.vue'
import alertModel from './alert.vue'
import monthPicker from './monthpicker.vue'
import datePicker from './datepicker.vue'
export default {
    components: {
        commonHeader,
        mapPicker,
        stepSecond,
        stepThird,
        alertModel,
        birthDate,
        monthPicker,
        datePicker
    },
    watch: {

    },
    data() {
        return {
            types: '党政机关、事业单位、国有企业、外资企业、私营企业、个体工商户、军队、学生、其他',
            datepickerShow: [false],
            formData1: '',
            formData2: '',
            formData3: '',
            nation: [],
            politicalBackground: [],
            culture: [],
            group: [],
            alertShow: false,
            tips: '',
            alertFunc: '',
            role: this.$store.state.user.role
        }
    },
    methods: {
        idcardInput() {
            if (this.formData1.idnumber.length >= 14) {
                var date = this.formData1.idnumber.substring(6, 14)
                this.$refs.birthdate.setTime(date.substring(0, 4), date.substring(4, 6), date.substring(6, 8));
            }
            if (this.formData1.idnumber.length >= 17) {
                var sex = this.formData1.idnumber.substring(16, 17);
                this.formData1.gender = sex % 2
            }
        },
        showDatepicker(index) {
            this.$set(this.datepickerShow, index, !this.datepickerShow[index])
        },
        catchChildDate(data) {
            this.formData2.awards[data.index].date = data.date
            this.$set(this.datepickerShow, data.index, false)
        },
        save(op) {
            let photos = []
            for (let i = 0; i < this.formData2.photos.length; i++) {
                photos.push(this.formData2.photos[i].path)
            }
            let id = this.$route.query.id
            let params = {
                data: this.formData1,
                photos: photos,
                awards: this.formData2.awards,
                resume: this.formData3
            }
            let config = {
                headers: {
                    'Content-Type': 'text/plain'
                }
            }
            let option = op ? `&op=${op}` : ''
            this.$axios.post(`/api/wenlian/completed?request_id=${id}${option}`, params, config).then(res => {
                if (res.data.result == 1) {
                    this.alert(res.data.msg, () => {
                        this.$router.push('dataTypein')
                    })
                } else {
                    this.alert(res.data.msg)
                }

            })
        },
        catchStep3Start(date) {
            this.formData3[date.index].startdate = date.date
        },
        catchStep3End(date) {
            this.formData3[date.index].enddate = date.date
        },
        removePhoto(index) {
            this.formData2.photos.splice(index, 1)
        },
        addStep2() {
            console.log(this.datepickerShow)
            this.datepickerShow.push(false)
            this.formData2.awards.push({
                date: '',
                place: '',
                organizer: '',
                press: '',
                awards: ''
            })
        },
        addStep3() {
            this.formData3.push({
                startdate: '',
                exp: '',
                enddate: ''
            })
        },
        removeStep2(index) {
            this.datepickerShow.splice(index, 1)
            this.formData2.awards.splice(index, 1)
        },
        removeStep3(index) {
            this.formData3.splice(index, 1)
        },
        getBirthdate(date) {
            if (this.formData1) {
                this.formData1.birthdate = date.birthdate
            }
        },
        catchChildDate1(date) {
            console.log(date)
            if (this.formData1) {
                this.formData1.joindate_n = date.date
            }
        },
        catchChildDate2(date) {
            console.log(date)
            // this.formData1.joindate_p = date.date
            if (this.formData1) {
                this.formData1.joindate_p = date.date
            }
        },
        catchChildDate3(date) {
            // this.formData1.joindate_c = date.date
            console.log(date)
            if (this.formData1) {
                this.formData1.joindate_c = date.date
            }
        },
        uploadImage(e) {
            this.loading = true
            let that = this
            let img = e.target.files[0];
            let param = new FormData()
            param.append('file', img)
            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
            this.$axios.post('/api/wenlian/upload', param, config)
                .then(res => {
                    this.loading = false
                    if (res.data.result === 1) {
                        this.formData1.photo = res.data.url
                        this.alert(res.data.msg)
                    } else {
                        this.alert(res.data.msg)
                    }
                })
        },
        photosUpload(e) {
            let that = this
            let img = e.target.files[0];
            let param = new FormData()
            param.append('file', img)
            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
            this.$axios.post('/api/wenlian/upload', param, config)
                .then(res => {
                    if (res.data.result === 1) {
                        this.formData2.photos.push({ path: res.data.url })
                        this.alert(res.data.msg)
                    } else {
                        this.alert(res.data.msg)
                    }
                })
        },
        catchClose(data) {
            this.alertShow = data.show
        },
        alert(msg, func) {
            this.alertShow = true
            this.tips = msg
            this.alertFunc = func
        },
        checkTime(time) {
            let date = new Date(time)
            if (date.getTime()) {
                return time
            } else {
                return ''
            }
        },
        submit() {
            let formData = this.formData1
            let id = this.$route.query.id
            this.$axios.post("/api/wenlian/step1?id=" + id, this.qs.stringify(formData)).then(res => {
                if (res.data.result == 1) {
                    this.$router.push({
                        path: '/applyStep2',
                        query: {
                            id: res.data.request_id
                        }
                    })
                } else {
                    this.alert(res.data.msg)
                }
            })
        }
    },
    mounted() {
        document.body.addEventListener('click', (e) => {
            console.log("-------body-click--------")
            for (let i = 0; i < this.datepickerShow.length; i++) {
                this.$set(this.datepickerShow, i, false)
            }
        })
        this.nation = nation
        this.politicalBackground = politicalBackground
        this.culture = culture
        this.group = group
        let id = this.$route.query.id
        this.$axios.get('/api/wenlian/requestdetail', {
            params: {
                id: id,
                step: 1
            }
        }).then(res => {
            if (res.data.result == 1) {
                this.formData1 = res.data.data
            }
            // else {
            //   this.formData1 = { "id": "4359", "userid": "81", "name": "\u67f4\u4eac\u6b63", "pinyin": "chaijingzheng", "penname": "\u7af9\u5f71\u62c2\u5c18", "gender": "1", "birthdate": "1971-11-01", "nation": "\u6c49\u65cf", "political": "\u4e2d\u56fd\u5171\u4ea7\u515a\u515a\u5458", "education": "\u5927\u5b66\u672c\u79d1", "birthplace": "\u5c71\u4e1c\u7701\u9752\u5c9b\u5e02\u897f\u6d77\u5cb8\u65b0\u533a\u5b9d\u5c71\u9547\u4e0b\u67f4\u6751", "employer": "\u9752\u5c9b\u5e02\u897f\u6d77\u5cb8\u65b0\u533a\u7b2c\u4e09\u9ad8\u7ea7\u4e2d\u5b66", "position": "\u6559\u5e08", "positiontitle": "\u4e2d\u5b66\u9ad8\u7ea7\u6559\u5e08", "idnumber": "370223197111295333", "union": "\u9752\u5c9b\u5e02\u4f5c\u5bb6\u534f\u4f1a", "address": "\u5c71\u4e1c\u7701\u9752\u5c9b\u5e02\u897f\u6d77\u5cb8\u65b0\u533a\u7b2c\u4e09\u9ad8\u7ea7\u4e2d\u5b66", "telephone": "\u65e0", "email": "249707981@qq.com", "postcode": "266425", "wechat": "A15154281023", "officephone": "\u65e0", "mobile": "15154281023", "joindate_n": "", "joindate_p": "", "joindate_c": "", "mid_n": "", "mid_p": "", "mid_c": "", "posi_n": "", "posi_p": "", "posi_c": "", "photo": "", "intime": "2020-09-30 08:29:11", "status": "\u5f85\u5ba1\u6838", "memberid": "", "isdeleted": "0", "remark": "\u5165\u4f1a\u8981\u6c42\u5728\u5e02\u7ea7\u4ee5\u4e0a\u62a5\u520a\u6742\u5fd7\u53d1\u8868\u6587\u5b66\u4f5c\u54c1\u4e24\u7bc7\u4ee5\u4e0a\u6216\u8005\u83b7\u5f97\u5e02\u7ea7\u4ee5\u4e0a\u6587\u5b66\u5956\u9879\u3002" }
            // }
        })
        this.$axios.get('/api/wenlian/requestdetail', {
            params: {
                id: id,
                step: 2
            }
        }).then(res => {
            if (res.data.result == 1) {
                this.formData2 = res.data.data
            }
            else {
                this.formData2 = { "awards": [{ "id": "125", "mid": "4359", "date": "2020-03", "place": "\u70df\u53f0\u5e02", "organizer": "\u5c71\u4e1c\u6563\u6587\u5b66\u4f1a", "press": "\u80f6\u4e1c\u6563\u6587\u5341\u4e8c\u5bb6\uff08\u7b2c\u4e09\u8f91\uff09", "awards": "\u53d1\u8868\u6563\u6587\u516d\u7bc7\uff0c\u83b72020\u5e74\u5ea6\u80f6\u4e1c\u6563\u6587\u4f18\u79c0\u4f5c\u54c1\u5956" }, { "id": "126", "mid": "4359", "date": "2020-05", "place": "\u70df\u53f0\u5e02", "organizer": "\u5c71\u4e1c\u6563\u6587\u5b66\u4f1a", "press": "\u80f6\u4e1c\u6563\u6587\u5e74\u9009", "awards": "\u53d1\u8868\u300a\u4e2d\u5e74\u4e4b\u60d1\u300b" }, { "id": "127", "mid": "4359", "date": "2012-11", "place": "\u897f\u6d77\u5cb8\u65b0\u533a", "organizer": "\u4e2d\u56fd\u6821\u5916\u6559\u80b2\u6742\u5fd7\u793e\u7f16\u8f91\u90e8", "press": "\u300a\u4e2d\u56fd\u6821\u5916\u6559\u80b2\u300b\u6742\u5fd7", "awards": "\u53d1\u8868\u300a\u6d45\u8c08\u5fb7\u80b2\u6559\u80b2\u7684\u5b9e\u65bd\u9014\u5f84\u300b" }, { "id": "695", "mid": "4359", "date": "2020-11", "place": "", "organizer": "", "press": "", "awards": "" }], "photos": [{ "id": "3645", "mid": "4359", "path": "http:\/\/res2.shiminjia.com\/wenlian\/202109\/23\/153429_680.jpg", "intime": "2021-09-23 15:38:17", "desc": null }, { "id": "3646", "mid": "4359", "path": "http:\/\/res2.shiminjia.com\/wenlian\/202109\/23\/153552_581.jpg", "intime": "2021-09-23 15:38:17", "desc": null }, { "id": "3647", "mid": "4359", "path": "http:\/\/res2.shiminjia.com\/wenlian\/202109\/23\/153558_531.jpg", "intime": "2021-09-23 15:38:17", "desc": null }, { "id": "3648", "mid": "4359", "path": "http:\/\/res2.shiminjia.com\/wenlian\/202109\/23\/153609_993.jpg", "intime": "2021-09-23 15:38:17", "desc": null }, { "id": "3649", "mid": "4359", "path": "http:\/\/res2.shiminjia.com\/wenlian\/202109\/23\/153618_471.jpg", "intime": "2021-09-23 15:38:17", "desc": null }, { "id": "3650", "mid": "4359", "path": "http:\/\/res2.shiminjia.com\/wenlian\/202109\/23\/153625_707.jpg", "intime": "2021-09-23 15:38:17", "desc": null }, { "id": "3651", "mid": "4359", "path": "http:\/\/res2.shiminjia.com\/wenlian\/202109\/23\/153642_880.jpg", "intime": "2021-09-23 15:38:17", "desc": null }, { "id": "3652", "mid": "4359", "path": "http:\/\/res2.shiminjia.com\/wenlian\/202109\/23\/153649_337.jpg", "intime": "2021-09-23 15:38:17", "desc": null }, { "id": "3653", "mid": "4359", "path": "http:\/\/res2.shiminjia.com\/wenlian\/202109\/23\/153703_718.jpg", "intime": "2021-09-23 15:38:17", "desc": null }] }
            }
        })
        this.$axios.get('/api/wenlian/requestdetail', {
            params: {
                id: id,
                step: 3
            }
        }).then(res => {
            if (res.data.result == 1) {
                this.formData3 = res.data.data
            }
            // else {
            //   this.formData3 = [{ "id": "119", "mid": "4359", "startdate": "1993-07", "enddate": "", "exp": "\u9752\u5c9b\u5e02\u897f\u6d77\u5cb8\u65b0\u533a\u7b2c\u4e09\u9ad8\u7ea7\u4e2d\u5b66  \u4efb\u6559\u9ad8\u4e2d\u8bed\u6587" }]
            // }
        })
    }
}
</script>
  
<style lang="css" scoped>
.detail .btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active,
.show>.btn-primary.dropdown-toggle {
    opacity: 0.5;
    background-color: #18a689;
    border-color: #18a689;
}

.detail .btn-primary {
    background-color: #18a689;
    border-color: #18a689;
    width: 200px;
}

.detail .btn-light {
    width: 200px;
}

.detail .btn-primary:hover {
    background-color: #1ab394;
    border-color: #1ab394;
}

.detail .btn-primary.disabled {
    opacity: 0.5;
    background-color: #18a689;
    border-color: #18a689;
}

.detail .part {
    padding: 20px 0;
}

.detail .border {
    width: 100%;
    position: relative;
    min-height: 360px;
    overflow: hidden;
}

.detail .border::after {
    content: attr(data-title);
    position: absolute;
    color: #999;
    font-size: 14px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
}

.detail .minHeight {
    min-height: 360px;
}

.detail .border img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    z-index: 9999;
    width: 100%;
    height: auto;
}

.detail .fullScreen {
    height: 100%;
}

.detail .page-link {
    color: #33434b;
}

.detail .page-link:hover {
    background: #f4f4f4;
    color: #33434b;
}

.detail .page-link.active {
    background: #f4f4f4;
}

.detail .custom-file-label::after {
    content: attr(data-avatar);
    border-radius: 0.25rem;
    text-align: center;
    width: 100%;
    height: 100%;
}

.detail .custom-file-label {
    border: none;
}

.detail .red {
    color: red;
    margin: 0 5px;
}

.detail .form-group label {
    font-size: 15px;
    color: #33434b;
}

.detail input,
.detail select,
.detail option,
.detail .textarea,
.detail .form-check label {
    color: #33434b;
    font-size: 15px;
}

.detail .step2 .custom-file-label::after {
    content: "证明材料上传";
    border-radius: 0.25rem;
    text-align: center;
    width: 100%;
    height: 100%;
}

.detail .step2 .custom-file-label {
    border: none;
}

.detail .step2 .red {
    color: red;
    margin: 0 5px;
}

.detail .step2 .sub-tit {
    color: #33434b;
    font-size: 16px;
    padding-left: 10px;
    margin-bottom: 15px;
}

.detail .step2 table td,
table th {
    color: #333;
}

.detail .step2 .table td,
.table th {
    padding: 0.75rem;
    vertical-align: top;
    border-top: none;
}

.detail .step2 .form-group {
    margin-bottom: 0;
}

.detail .step2 .upload-image {
    margin-top: 20px;
}

.detail .step2 .upload-image img {
    height: 150px;
    width: auto;
    z-index: 9999;
}

.detail .step2 .custom-file {
    margin-top: 0%;
}

.detail .step2 .example-img {
    height: 150px;
    border: 1px solid #dee2e6;
    border-radius: 5px;
    position: relative;
}

.detail .step2 .example-img:after {
    content: "+";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #dee2e6;
    font-size: 50px;
}

.detail .step2 .border {
    min-height: auto;
}

.detail .step2 .border::after {
    content: "";
}

.detail .sub-tit {
    color: #33434b;
    font-size: 16px;
    padding-left: 10px;
    margin-bottom: 15px;
}

.detail textarea {
    min-height: 200px;
}

.detail .form-span {
    line-height: 1.5;
    color: #33434b;
    font-size: 15px;
    display: block;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #33434b;
    border-radius: 0.25rem;
    -webkit-transition: border-color 0.15s ease-in-out,
        -webkit-box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out,
        -webkit-box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
        -webkit-box-shadow 0.15s ease-in-out;
}

.detail table {
    margin-bottom: 0;
}

.address {
    height: auto !important;
}

.overflowAuto {
    overflow: auto;
}

.remove {
    background: #18a689;
    color: #fff;
    width: 25px;
    height: 25px;
    line-height: 22px;
    display: inline-block;
    border-radius: 50%;
    text-align: center;
    font-size: 25px;
    margin-top: 5px;
}

.detail .fixedWidth {
    width: 200px;
}

.detail .example-img>img {
    position: relative;
    z-index: 999;
}

.delPhoto {
    position: absolute;
    top: -10px;
    right: -10px;
    z-index: 99999;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: #f31a1a;
    color: #fff;
    line-height: 22px;
    text-align: center;
    font-size: 25px;
}

.form-control[readonly] {
    background: none !important;
}

@media screen and (max-width: 750px) {
    .col-form-label {
        text-align: left;
    }

    .table {
        width: 1400px;
    }

    .detail .step2 .upload-image {
        text-align: center;
    }

    .detail .step2 .upload-image .col-sm-auto {
        margin-bottom: 20px;
    }

    .detail .step2 .upload-image img {
        width: 100%;
        object-fit: cover;
    }
}
</style>
  


// WEBPACK FOOTER //
// src/components/complete.vue